<template>
  <div>
    <v-subheader>{{ $t("settings.company.title") }}</v-subheader>
    <v-form>
    <v-row v-if="company.logo">
        <v-col cols="2">
            <v-img
            class="bg-white"
            max-width="150"
            max-height="150"
            height="100%"
            :aspect-ratio="1"
            :src="company.logo"
            contain
          ></v-img>
          <v-btn
            style="color: #fff"
            :disabled="updating || editedCompany.name.length < 1"
            color="red"
            @click="deleteLogo"
            >Usuń</v-btn
          >
        </v-col>
    </v-row>
      <v-row>
        <v-col cols="12" xs="6" md="3" lg="3">
          <v-text-field
            type="text"
            v-model="editedCompany.name"
            :label="$t('company.name')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="6" md="3" lg="2">
          <v-text-field
            type="text"
            v-model="editedCompany.nip"
            :label="$t('company.nip')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="6" lg="5">
          <v-text-field
            type="text"
            v-model="editedCompany.address"
            :label="$t('company.address')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="6" lg="2">
          <v-text-field
            type="text"
            v-model="editedCompany.phone"
            :label="$t('company.phone')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="6" lg="5">
          <v-text-field
            type="text"
            v-model="editedCompany.contact"
            :label="$t('company.contact')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="6" lg="3">
          <v-text-field
            type="text"
            v-model="editedCompany.account"
            :label="$t('company.account')"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="6" lg="2">
          <v-text-field
            type="text"
            v-model="editedCompany.payment"
            :label="$t('company.payment')"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" >
          <v-file-input
            label="Logo"
            v-model="logo"
            show-size
            filled
            prepend-icon="mdi-camera"
          ></v-file-input>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="10" xs="10" md="4" lg="2" align-self="end">
          <v-progress-circular
            v-if="updating"
            color="secondary"
            indeterminate
          ></v-progress-circular>

          <v-btn
            style="color: #fff"
            :disabled="updating || editedCompany.name.length < 1"
            color="light-green"
            @click="update"
            >{{ $t("base.update") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "MyCompany",
  computed: {
    company() {
        return this.$store.state.company;
    },
  },
  data() {
    return {
      editedCompany: { name: "" },
      updating: false,
      logo: null,
    };
  },
  methods: {
    update() {
      this.updating = true;
      let config = {
        headers: { "content-type": "multipart/form-data" },
      };
      let formData = new FormData();
        formData.append("id", parseInt(this.editedCompany.id));
        formData.append("company", JSON.stringify(this.editedCompany));
        formData.append("logo", this.logo);
      this.$http
        .post("company/update", formData, config)
        .then((response) => {
          this.updating = false;
          this.$store.commit("updateMyCompany", response.data);
        })
        .catch((error) => {
          this.updating = false;
          console.log(error);
        });
    },
    deleteLogo(){
        this.$http
        .delete("company/delete-logo", {id: this.company.id})
        .then((response) => {
          this.updating = false;
          this.$store.commit("updateMyCompany", response.data);
          this.logo = null;
          this.$forceUpdate()
        })
        .catch((error) => {
          this.updating = false;
          console.log(error);
        });
    }
  },
  mounted() {
    this.$store.dispatch("loadMyCompany").then(() => {
      this.editedCompany = Object.assign({}, this.company);
    });
  },
};
</script>

<style scoped>
</style>
